export const MUTATION_KEYS = {
    subscribeToHost: 'subscribeToHost',
    unsubscribe: 'unsubscribe'
}

export const QUERY_KEYS = {
    subscribedGuestsV3: 'subscribedGuestsV3',
    subscribedHostsV3: 'subscribedHostsV3',
    subscriptions_amounts: 'subscriptions-amounts'
}
